var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 734,
    height: 49,
    viewBox: "0 0 734 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5859 49L997.586 49V0L65.5859 0V49Z",
    fill: "#1B7691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5859 49H53.5859L53.5859 0H42.5859L42.5859 49Z",
    fill: "#1B7691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5859 49H32.5859L32.5859 0H21.5859L21.5859 49Z",
    fill: "#1B7691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.585938 49H11.5859L11.5859 0H0.585937L0.585938 49Z",
    fill: "#1B7691"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftblue);
export default __webpack_public_path__ + "static/media/leftblue.990f303a02bb425cad9a74712dac42b3.svg";
export { ForwardRef as ReactComponent };